import { connect } from 'react-redux';

import { getFriendHeaderAction } from '../../actions/friendProfileActions';
import FriendProfileHeader from '../../components/FriendProfile/friendProfileHeader.jsx';
import { getFriendHeaderSelector } from '../../components/FriendProfile/friendProfileSelectors';

const mapStateToProps = (state, ownProps) => ({
  friendInformation: getFriendHeaderSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadFriendHeader: () => {
    dispatch(getFriendHeaderAction());
  },
});

const FriendHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FriendProfileHeader);

export default FriendHeaderContainer;
